import { Component, OnInit } from '@angular/core';
import { WebUserService } from '../../../services/webuser.service';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { FilterService } from '../../../services/filter.service';
import { Page } from '../../../models/paging/page';

@Component({
  selector: 'app-webusers',
  templateUrl: './webusers.component.html',
  styleUrls: ['./webusers.component.scss']
})
export class WebusersComponent implements OnInit {
  loading: boolean = false;
  readOnly: boolean = false;
  rows = [];
  page = new Page();

  filter: any = {
    company_Id: undefined,
    location_Id: undefined,
    name: '',
    email: ''
  };

  default_filters = JSON.parse(JSON.stringify(this.filter));
  constructor(private webUsersService: WebUserService, public router: Router, private authService: AuthService, private filterService: FilterService) {
    if (this.authService.currentUser.value.userProfileId != 1 && this.authService.currentUser.value.userProfileId != 4) {
      this.readOnly = true;
    }

    if (this.authService.currentUser.value.userProfileId == 3) {
      //user is a client, so throw them to the reports page
      this.router.navigate(['']);
    }

    //console.log("This is being hit");
    this.page = new Page();
    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = 'asc';
    this.page.sortBy = "email";

    var filters = this.filterService.getFilters(this.authService.currentUser.value.id, this.router.url);
    if (filters != null) {
      this.filter = filters;
      this.loadTable()
    }


  }

  back() {
    this.router.navigate(['']);
  }

  getRowClass = (row) => {
    return {
      'row-expired': row.expired,
      'row': true
    }
  }
  // [count]="page.totalElements" [offset]="page.pageNumber" [limit]="page.size"
  ngOnInit(): void {

    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = 'asc';
    this.page.sortBy = "email";

    this.loadTable();
  }

  loadTable() {
    this.loading = true;
    this.webUsersService.getTable(this.page, this.filter.company_Id, this.filter.location_Id, this.filter.name, this.filter.email).then((rows) => {
      this.page = rows.page;
      this.rows = rows.data;
      this.loading = false;
    });
  }

  rebind() {
    this.loadTable();
  }
  resetFilters() {
    this.filter = this.filterService.parseFilters(JSON.stringify(this.default_filters));
    this.loadTable();
  }

  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;

    this.loadTable();
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }
    this.loadTable();

  }
  onCompanyChange(value) {
    this.filter.location_Id = 0;
    //console.log(value);
    if (value == undefined)
      this.filter.company_Id = undefined;
    else
      this.filter.company_Id = value.id;

  }

  onLocationChange(value) {
    if (value == undefined)
      this.filter.location_Id = undefined;
    else
      this.filter.location_Id = value.id;

  }

  add() {
    this.router.navigate(['users/manage']);
  }


}
